import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { BusinessSolutionsService } from 'src/app/services/business-solutions/business-solutions.service';
import { AddCodeComponent } from '../add-code/add-code.component';
import { CookieService } from 'ngx-cookie-service';
import { getLanguageCookie } from 'src/assets/language';
import { CorporationDimensionsService } from "../../../../services/corporation-dimensions/corporation-dimensions.service";
import { addAlert, apiOfflineAsync } from "../../../../layouts/pages/pages.component";
import { StrategyComponent } from '../strategy/strategy.component';
import { PeopleComponent } from '../people/people.component';
import { TechnologyComponent } from '../technology/technology.component';
import { AttachmentsComponent } from '../attachments/attachments.component';
import { ComplementsComponent } from '../complements/complements.component';
import { ConfigurationsComponent } from '../configurations/configurations.component';
import { IntegrationsComponent } from '../integrations/integrations.component';
import { RulesComponent } from '../rules/rules.component';
import { IndicatorsComponent } from '../indicators/indicators.component';
import { AbaMaturityComponent } from '../maturity/maturity.component';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { TransactionComponent } from '../transaction/transaction.component';
import { to64decode, to64encode } from 'src/app/helpers/base64';
import { ProjectComponent } from '../project/project.component';
import { ExtendedAttributesComponent } from '../extended-attributes/extended-attributes.component';
import { LinkComponent } from '../link/link.component';
import { fixedLevels } from 'src/assets/const/fixedLevelsJson';
import { ContactsComponent } from '../crm/contacts/contacts.component';
import { StrategicPlanningComponent } from '../crm/strategic-planning/strategic-planning.component';
import { PhaseComponent } from '../crm/phase/phase.component';
import { FteComponent } from '../crm/fte/fte.component';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})

export class EditComponent {
  @ViewChild(AddCodeComponent) addCodeComponent!: AddCodeComponent;
  @ViewChild(StrategyComponent) strategyComponent!: StrategyComponent;
  @ViewChild(PeopleComponent) peopleComponent!: PeopleComponent;
  @ViewChild(TechnologyComponent) technologyComponent!: TechnologyComponent;
  @ViewChild(AbaMaturityComponent) maturityComponent!: AbaMaturityComponent;
  @ViewChild(AttachmentsComponent) attachmentsComponent!: AttachmentsComponent;
  @ViewChild(IndicatorsComponent) indicatorsComponent!: IndicatorsComponent;
  @ViewChild(ComplementsComponent) complementsComponent!: ComplementsComponent;
  @ViewChild(ConfigurationsComponent) configurationsComponent!: ConfigurationsComponent;
  @ViewChild(IntegrationsComponent) integrationsComponent!: IntegrationsComponent;
  @ViewChild(RulesComponent) rulesComponent!: RulesComponent;
  @ViewChild(TransactionComponent) transactionComponent!: TransactionComponent;
  @ViewChild(ProjectComponent) projectComponent!: ProjectComponent;
  @ViewChild(ExtendedAttributesComponent) extendedAttributes!: ExtendedAttributesComponent;
  @ViewChild(LinkComponent) links!: LinkComponent;
  @ViewChild(ContactsComponent) contacts!: ContactsComponent;
  @ViewChild(PhaseComponent) phase!: PhaseComponent;
  @ViewChild(FteComponent) fteTab!: FteComponent;
  @ViewChild(StrategicPlanningComponent) strategicPlanning!: StrategicPlanningComponent

  @ViewChild('buttonContainer') buttonContainer!: ElementRef;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  @Output() toggleModalEdit: EventEmitter<void> = new EventEmitter<void>();
  @Output() getBusinessTree: EventEmitter<void> = new EventEmitter<void>();
  @Output() updateFiles: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitNavigateOriginNode: EventEmitter<any> = new EventEmitter<any>();

  @Input() properties: any = {}
  @Input() parameters: any = {}

  protected readonly Object = Object;

  corporation: any = {}

  selectedFlag: any = { lang: 'en', file: 'us.svg' };

  nameProcess!: string;

  arrayDimension: any = []
  isEdit: boolean = false;
  viewDimension: number = 1;
  title = 'Add Code';
  icon = 'fa-diagram-next';

  selectedOrganogramResponsible: any = {
    label: ''
  }

  selectedOrganogramExecuting: any = {
    label: ''
  }

  columns: any = {
    strategy: {},
    people: {},
    technology: {}
  }

  dimensions: any = {
    strategy: [],
    people: [],
    technology: {}
  }

  item: any

  tabArray: any = []

  temp: any = {}
  isChangeTree: boolean = false;
  hasNameError: boolean = false

  constructor(
    private corporationDimensionsService: CorporationDimensionsService,
    private cdr: ChangeDetectorRef
  ) {
    this.toggleDimension(1)
  }

  async ngOnInit() {
    this.selectedFlag = to64decode(localStorage.getItem('language'))
    await this.getDimensions()
    this.tabArray = this.parameters.optionsArray.tabArray
    // await this.toggleDimension(1)
    await this.initDescription()
    await this.initIndicators()

    if (!this.parameters.item.parent) {
      this.parameters.parent = {}
      this.parameters.parent.label = this.parameters.business
    } else {
      this.parameters.parent.label = this.parameters.item.parent.label
    }

    this.temp = JSON.parse(JSON.stringify(this.parameters.item));

    this.parameters.item.level = this.parameters.item.level > 0 ? this.parameters.item.level : 1

    if (!this.parameters.crmTree) {
      if (this.parameters.guidelineArray[this.parameters.item.level - 1]?.tabs?.length > 0) {
        this.tabArray = this.parameters.optionsArray.tabArray.filter(
          (tab: any) => this.parameters.guidelineArray[this.parameters.item.level - 1]?.tabs?.includes(tab.slug)
            || tab.slug == 'addCode'
            || (this.parameters.item.level == 3 && this.parameters.item.crm == 'opportunity' && (tab.slug == 'contacts' || tab.slug == 'strategicPlanning'))
            || (this.parameters.item.level == 4 && this.parameters.item.crm == 'opportunity' && (tab.slug == 'contacts' || tab.slug == 'phase' || tab.slug == 'fte')))
      } else {
        this.tabArray = this.parameters.optionsArray.tabArray.filter(
          (tab: any) => tab.slug == 'addCode'
            || (this.parameters.item.level == 3 && this.parameters.item.crm == 'opportunity' && (tab.slug == 'contacts' || tab.slug == 'strategicPlanning'))
            || (this.parameters.item.level == 4 && this.parameters.item.crm == 'opportunity' && (tab.slug == 'contacts' || tab.slug == 'phase' || tab.slug == 'fte')))
      }
    } else {
      this.tabArray = this.parameters?.optionsArray?.tabArray ?? []
      this.parameters.item.crm = 'opportunity'
    }

    if (this.parameters.arrayOrganograms) {
      this.parameters.arrayOrganograms.forEach((item: any) => {
        if (this.parameters.item.description.organogram_responsible && this.parameters.item.description.organogram_responsible.uuid && item.uuid == this.parameters.item.description.organogram_responsible.uuid) {
          this.selectedOrganogramResponsible = item
        }
        if (this.parameters.item.description.organogram_executing && this.parameters.item.description.organogram_executing.uuid && item.uuid == this.parameters.item.description.organogram_executing.uuid) {
          this.selectedOrganogramExecuting = item
        }
      });
    }
  }

  ngAfterViewInit() {
    this.scrollContainer.nativeElement.scrollLeft = 0;
  }

  scrollLeft() {
    this.scrollContainer.nativeElement.scrollLeft -= 250;
  }

  scrollRight() {
    this.scrollContainer.nativeElement.scrollLeft += 250;
  }

  async initDescription() {
    this.parameters.item.description = this.parameters.item.description ?? {}
    this.parameters.item.description.importance = this.parameters.item.description.importance ?? '',
      this.parameters.item.description.frequency = this.parameters.item.description.frequency ?? '',
      this.parameters.item.description.fte = this.parameters.item.description.fte ?? 0,
      this.parameters.item.description.fte_cost = this.parameters.item.description.fte_cost ?? 0,
      this.parameters.item.description.fte_one = this.parameters.item.description.fte_one ?? 0,
      this.parameters.item.description.fte_cost_one = this.parameters.item.description.fte_cost_one ?? 0,
      this.parameters.item.description.sla_unit = this.parameters.item.description.sla_unit ?? ''
    this.parameters.item.description.sla = this.parameters.item.description.sla ?? '',
      this.parameters.item.description.description = this.parameters.item.description.description ?? '',
      this.parameters.item.description.link = this.parameters.item.description.link ?? '',
      this.parameters.item.description.strategy = this.parameters.item.description.strategy ?? ''
    this.parameters.item.description.people = this.parameters.item.description.people ?? ''
    this.parameters.item.description.skills = this.parameters.item.description.skills ?? ''
    this.parameters.item.description.technology = this.parameters.item.description.technology ?? ''
  }

  async initIndicators() {
    this.parameters.item.indicators = this.parameters.item.indicators ?? []
    this.parameters.item.complements = this.parameters.item.complements ?? []
    this.parameters.item.configurations = this.parameters.item.configurations ?? []
    this.parameters.item.integrations = this.parameters.item.integrations ?? []
    this.parameters.item.rules = this.parameters.item.rules ?? []
    this.parameters.item.contacts = this.parameters.item.contacts ?? []
    this.parameters.item.strategicPlanning = this.parameters.item.strategicPlanning ?? []
    this.parameters.item.phase = this.parameters.item.phase ?? {
      weeks: []
    }
    this.parameters.item.fte_tab = this.parameters.item.fte_tab ?? {
      months: []
    }
    this.parameters.item.transactions = this.parameters.item.transactions ?? []
    this.parameters.item.project = this.parameters.item.project ?? {}
    this.parameters.item.personas = this.parameters.item.personas ?? []
    this.parameters.item.personasClassification = this.parameters.item.personasClassification ?? []
    this.parameters.item.technologies_table = this.parameters.item.technologies_table ?? {}
    this.parameters.item.extendedAttributes = this.parameters.item.extendedAttributes ?? []
    this.parameters.item.links = this.parameters.item.links ?? []
    this.parameters.item.crm = this.parameters.item.crm ?? ''
    this.parameters.item.crmTree = this.parameters.crmTree ?? false
  }

  async getDimensions() {
    try {
      const response: any = await this.corporationDimensionsService.getDimensions()
      if (response.data) {
        this.dimensions = response.data
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  getLanguages(file: string) {
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  async toggleDimension(number: number = 1) {
    this.viewDimension = number
  }

  @HostListener('document:click', ['$event.target'])

  ngOnChanges(changes: SimpleChanges) {
    this.exitModal(false)
  }

  exitModal(hide: boolean = true): void {
    if (!hide) {
      return
    }

    if (this.isEdit) {
      this.isChangeTree = true;
      return
    }

    this.toggleModalEdit.emit();
  }

  async modalClose() {
    await Promise.all([this.exitModal()]);
  }

  updateText(json: any) {
    this.item = json.item
  }

  parametersValidation(): boolean {
    let inputs: any = []

    // this.parameters.item.code = this.parameters.inputs.code;
    // if (this.parameters.parent.code) {
    //   this.parameters.item.code = `${this.parameters.parent.code}.${this.parameters.inputs.code}`
    // }
    if (!this.parameters.item.label || this.parameters.item.label == '') {
      inputs.push(this.getLanguages('businessSolution/modal/addCode/process'))
    }
    if ((!this.parameters.item.phase?.entryDate || this.parameters.item.phase?.entryDate == '') && this.parameters.item.crm == 'opportunity' && this.parameters.item.level == 4) {
      inputs.push(`[${this.getLanguages('businessSolution/modal/phase/title')}] - ${this.getLanguages('businessSolution/modal/phase/entryDate')}`)
    }
    if (inputs.length > 0) {
      addAlert('orange', `${this.getLanguages('mandatoryField')}${inputs.join(`, `)}`)
      this.hasNameError = true
      return false
    }
    return true
  }

  async editBusinessTree() {
    this.isEdit = !this.isEdit;
    this.parameters.isEdit = this.isEdit

    if (!this.isEdit) {
      this.parameters.item = JSON.parse(JSON.stringify(this.temp));
      await this.getComponentDimension()
    }
  }

  async getComponentDimension() {
    switch (this.viewDimension) {
      case 1:
        if (this.addCodeComponent) {
          this.addCodeComponent.ngOnInit();
        }
        break;
      case 2:
        if (this.strategicPlanning) {
          this.strategicPlanning.ngOnInit();
        }
        break;
      case 3:
        if (this.contacts) {
          this.contacts.ngOnInit();
        }
        break;
      case 4:
        if (this.phase) {
          this.phase.ngOnInit();
        }
        break;
      case 5:
        if (this.fteTab) {
          this.fteTab.ngOnInit();
        }
        break;
      case 6:
        if (this.strategyComponent) {
          this.strategyComponent.ngOnInit();
        }
        break;
      case 7:
        if (this.peopleComponent) {
          this.peopleComponent.ngOnInit();
        }
        break;
      case 8:
        if (this.transactionComponent) {
          this.transactionComponent.ngOnInit();
        }
        break;
      case 9:
        if (this.technologyComponent) {
          this.technologyComponent.ngOnInit();
        }
        break;
      case 10:
        if (this.rulesComponent) {
          this.rulesComponent.ngOnInit();
        }
        break;
      case 11:
        if (this.maturityComponent) {
          this.maturityComponent.ngOnInit();
        }
        break;
      case 12:
        if (this.attachmentsComponent) {
          this.attachmentsComponent.ngOnInit();
        }
        break;
      case 13:
        if (this.indicatorsComponent) {
          this.indicatorsComponent.ngOnInit();
        }
        break;
      case 14:
        if (this.complementsComponent) {
          this.complementsComponent.ngOnInit();
        }
        break;
      case 15:
        if (this.configurationsComponent) {
          this.configurationsComponent.ngOnInit();
        }
        break;
      case 16:
        if (this.integrationsComponent) {
          this.integrationsComponent.ngOnInit();
        }
        break;
      case 17:
        if (this.projectComponent) {
          this.projectComponent.ngOnInit();
        }
        break;
      case 18:
        if (this.extendedAttributes) {
          this.extendedAttributes.ngOnInit();
        }
        break;
      case 19:
        if (this.links) {
          this.links.ngOnInit();
        }
        break;
      default:
        return null;
    }

    return
  }

  async setBusinessTree() {
    await this.approveProcess(false);
  }

  updateTree(array: any, updatedItem: any) {
    let flag = false;
    let findItem: any = {};
    let findI = -1;

    for (let i = 0; i < array.length; i++) {
      const item = array[i];
      if (item.uuid != updatedItem.uuid && item.master == updatedItem.master && updatedItem.label == item.label) {
        this.hasNameError = true;
        addAlert('orange', this.getLanguages('errors/businessTree/SameNameElement'))
        flag = false
        return
      } else if (item.uuid === updatedItem.uuid) {
        findItem = item
        findI = i
        flag = true
      } else if (item.children && item.children.length > 0) {
        this.updateTree(item.children, updatedItem);
      }
    }

    if (flag) {
      array[findI] = {
        ...findItem,
        ...updatedItem,
      };
    }
  }

  getDimension() {
    let value = ''
    if (this.viewDimension == 2) value = 'strategicPlanning'
    if (this.viewDimension == 3) value = 'contacts'
    if (this.viewDimension == 4) value = 'phase'
    if (this.viewDimension == 5) value = 'fte'
    if (this.viewDimension == 6) value = 'strategy'
    if (this.viewDimension == 7) value = 'people'
    if (this.viewDimension == 8) value = 'transactions'
    if (this.viewDimension == 9) value = 'technology'
    if (this.viewDimension == 10) value = 'rules'
    if (this.viewDimension == 11) value = 'maturity'
    if (this.viewDimension == 12) value = 'attachments'
    if (this.viewDimension == 13) value = 'indicators'
    if (this.viewDimension == 14) value = 'complements'
    if (this.viewDimension == 15) value = 'configurations'
    if (this.viewDimension == 16) value = 'integrations'
    if (this.viewDimension == 17) value = 'project'
    if (this.viewDimension == 18) value = 'extendedAttributes'
    if (this.viewDimension == 19) value = 'links'

    return value == '' ? '' : `- ${this.getLanguages(`businessSolution/modal/${value}/title`)}`
  }

  formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  getLabel(label: string): string {
    const index = this.parameters.item?.level * (-1)

    if (this.parameters.item?.level < 0) {
      const expectedTag = `[${fixedLevels[index - 1]?.acronym}] `;

      label = label.replace(/^\[.*?\]\s*/, '');

      label = expectedTag + label;
    }

    return label;
  }

  async approveProcess(value?: boolean) {
    this.hasNameError = false

    this.parameters.item.is_approved = value ?? !this.parameters.item.is_approved
    await this.findClones()
    if (!this.parametersValidation()) {
      return
    }
    this.parameters.item.created_at = this.parameters.item.created_at ? this.parameters.item.created_at : this.formatDate(new Date()),
      this.parameters.item.updated_at = this.formatDate(new Date())
    this.parameters.item.userCreated = this.parameters?.item?.userCreated ? this.parameters?.item?.userCreated : this.properties?.me?.name,
      this.parameters.item.userUpdated = this.properties?.me?.name ?? '',
      this.parameters.item.label = this.getLabel(this.parameters.item.label)
    await this.updateDateTimeExtendedAttribute()

    this.updateTree(this.parameters.filesOld, this.parameters.item);

    if (!this.hasNameError) {
      this.updateFiles.emit({ files: this.parameters.filesOld, item: { ...this.parameters.item } });
      this.toggleModalEdit.emit();
    }
  }

  async findClones() {
    const nodeCloned = {
      is_approved: this.parameters.item.is_approved
    };

    const forEachTree = (node: any) => {
      if (node.uuid !== undefined) {
        if (this.parameters.item.clones !== undefined && this.parameters.item.clones.includes(node.uuid)) {
          Object.assign(node, nodeCloned);
        }
      }

      if (node.children && node.children.length > 0) {
        node.children.forEach(forEachTree);
      }
    };

    if (this.parameters.filesOld && Array.isArray(this.parameters.filesOld)) {
      this.parameters.filesOld.forEach(forEachTree);
    }
  }

  getSystemPermission(screen: string, action: string) {
    return systemPermissionsNew(screen, action)
  }

  toggleChangeTree(event: any) {
    this.isChangeTree = !this.isChangeTree

    if (event) {
      return
    }

    if (!this.isChangeTree) {
      this.toggleModalEdit.emit();
    }
  }

  getNameEntity(type: string = 'view') {
    let value = ''
    const level = this.parameters?.item?.level > 0 ? this.parameters?.item?.level : 1

    if (this.parameters.crmTree) {
      switch (level) {
        case 1:
          value = 'Jornada'
          break;
        case 2:
          value = 'Macro Processo'
          break;
        case 3:
          value = 'Cliente'
          break;
        case 4:
          value = 'Oportunidade'
          break;
        default:
          value = ''
          break;
      }
    }else{
      value = this.parameters.guidelineArray[level - 1]?.name
    }

    const index = level * (-1)

    if (!value || value == undefined) {
      value = ''
    }

    if (type == 'view') {
      if (level < 0 && !this.parameters.crmTree) {
        value = this.getLanguages('businessSolution/modal/view/title') + ' ' + fixedLevels[index - 1]?.name
      } else {
        value = this.selectedFlag.lang == 'en' ?
          value + ' ' + this.getLanguages('businessSolution/modal/view/title') :
          this.getLanguages('businessSolution/modal/view/title') + ' ' + value
      }
    } else {
      if (level < 0 && !this.parameters.crmTree) {
        value = this.getLanguages('businessSolution/modal/edit/title') + ' ' + fixedLevels[index - 1]?.name
      } else {
        value = this.getLanguages('businessSolution/modal/edit/title') + ' ' + value
      }
    }

    return value
  }

  goToOriginNode() {
    this.emitNavigateOriginNode.emit(this.parameters?.item?.clone_by)
  }

  async updateDateTimeExtendedAttribute() {
    let flag: boolean = false
    if (this.parameters.item.extendedAttributes && Array.isArray(this.parameters.item.extendedAttributes)) {
      this.parameters.item.extendedAttributes.forEach((item: any) => {
        if (this.temp.extendedAttributes && Array.isArray(this.temp.extendedAttributes)) {
          this.temp.extendedAttributes.forEach((temp: any) => {
            if (temp.uuid == item.uuid) {
              flag = true
              if (JSON.stringify(temp) !== JSON.stringify(item)) {
                item.updated_date = this.formatDate(new Date())
              }
            }
          });
        }
        if (!flag) {
          item.created_date = item.created_date ? item.created_date : this.formatDate(new Date())
          item.updated_date = this.formatDate(new Date())
        }
        flag = false
      });
    }
  }

  copyLink() {
    try {
      const obj = {
        corporation: {
          uuid: this.properties?.corporation?.uuid ? this.properties?.corporation?.uuid : '',
          name: this.properties?.corporation?.name ? this.properties?.corporation?.name : ''
        },
        node: {
          uuid: this.parameters?.item?.uuid,
          label: this.parameters?.item?.label
        }
      }

      const textToCopy = to64encode(obj);
      navigator.clipboard.writeText(textToCopy).then(() => {
        addAlert('success', this.getLanguages('businessSolution/top/copy/success'))
      }).catch((error) => {
        console.log(error)
        addAlert('orange', this.getLanguages('businessSolution/top/copy/warning'))
      });
    } catch (error) {
      console.log(error)
      addAlert('danger', this.getLanguages('businessSolution/top/copy/danger'))
    }
  }

  async reloadTabs() {
    if (this.parameters.guidelineArray[this.parameters.item.level - 1]?.tabs?.length > 0) {
      this.tabArray = this.parameters.optionsArray.tabArray.filter(
        (tab: any) => this.parameters.guidelineArray[this.parameters.item.level - 1]?.tabs?.includes(tab.slug)
          || tab.slug == 'addCode'
          || (this.parameters.item.level == 3 && this.parameters.item.crm == 'opportunity' && (tab.slug == 'contacts' || tab.slug == 'strategicPlanning'))
          || (this.parameters.item.level == 4 && this.parameters.item.crm == 'opportunity' && (tab.slug == 'contacts' || tab.slug == 'phase' || tab.slug == 'fte')))
    } else {
      this.tabArray = this.parameters.optionsArray.tabArray.filter(
        (tab: any) => tab.slug == 'addCode'
          || (this.parameters.item.level == 3 && this.parameters.item.crm == 'opportunity' && (tab.slug == 'contacts' || tab.slug == 'strategicPlanning'))
          || (this.parameters.item.level == 4 && this.parameters.item.crm == 'opportunity' && (tab.slug == 'contacts' || tab.slug == 'phase' || tab.slug == 'fte')))
    }
  }

  onCrmToggled(): void {
    if (this.parameters?.item?.crm === 'opportunity') {
      this.parameters.item.crm = undefined;
    } else {
      this.parameters.item.crm = 'opportunity';
    }

    this.reloadTabs();
    this.cdr.detectChanges();
  }
}
